module.exports = __webpack_public_path__ + "static/image 7-4f2b68e5b3026eb6dba997873281b65f.png";